var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:{dark:_vm.dark}},[_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App","dark":_vm.dark}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }